import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import { mediaQueries } from '../../theme'
import { Hr as BaseHr } from '../shared/rules'
import GroupShowcase from './group-showcase'

const Container = styled.div`
  min-width: 0;
`

const Hr = styled(BaseHr)`
  padding: ${p => `0 ${p.theme.space[6]}`};

  margin: ${p => `${p.theme.space[16]} 0`};

  ${mediaQueries.md} {
    padding: 0;
  }
`

const createTemplateLoadingStrategy = groupIndex => (templateIndex, wid) => {
  return groupIndex === 0 && templateIndex === 0 ? 'eager' : 'lazy'
}

const Showcase = ({ groups, templates, ...rest }) => (
  <Container {...rest}>
    {groups.map((g, index) => {
      const groupTemplates = templates.filter(t => t.group === g.name)
      return (
        <Fragment key={index}>
          <GroupShowcase
            group={g}
            templates={groupTemplates}
            templateLoadingStrategy={createTemplateLoadingStrategy(index)}
          />
          {index < groups.length - 1 && <Hr />}
        </Fragment>
      )
    })}
  </Container>
)

export default Showcase
